// frontend/src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe, login as apiLogin, logout as apiLogout } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('epro_token');
    if (token) {
      getMe()
        .then(setUser)
        .catch(() => localStorage.removeItem('epro_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem('epro_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await apiLogout().catch(() => {});
    localStorage.removeItem('epro_token');
    localStorage.removeItem('epro_active_program');
    localStorage.removeItem('epro_active_department');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
